// src/app.js
console.log("L'application a démarré !");

// config
let scoresAxes  = {
    logistique: 0,
    animation: 0,
    pratique: 0,
    reveur: 0,
    organisation: 0,
    espritDeCorps: 0,
    methode: 0,
    debrouille: 0
};

// Index de la question actuelle
let currentQuestionIndex = 0;
const questionsData = [
  {
    id: 1,
    q: "Ton repas scout préféré est...",
    r: [
      {
        text: "Risotto aux cèpes, préparé à l'avance, distribué de manière ultra-efficace.",
        points: { logistique: 3, organisation: 1 }
      },
      {
        text: "Pâtes au pesto, en dernière minute, avec un max de parmesan.",
        points: { debrouille: 3, animation: 1 }
      },
      {
        text: "Pizza maison, à la fiesta de fin de camp, où chacun raconte son meilleur souvenir.",
        points: { espritDeCorps: 2, reveur: 2 }
      },
      {
        text: "Dahl de lentilles corail et petits légumes, parfaitement équilibré.",
        points: { methode: 2, logistique: 1 }
      }
    ]
  },
  {
    id: 2,
    q: "Le noeud du trépied lâche : ta réaction ?",
    r: [
      {
        text: "Tu sors ton opinel et ton 1000 pistes nature. On reprend les bases !",
        points: { pratique: 3, methode: 2 }
      },
      {
        text: "Tu répares vite fait bien fait avec un noeud de cabestan. Ça tiendra !",
        points: { debrouille: 3, logistique: 1 }
      },
      {
        text: "Tu délègues : 'C'est qui le pro des nœuds ici ?' et tu supervises l'exécution.",
        points: { organisation: 2, espritDeCorps: 1 }
      },
      {
        text: "Tu demandes pourquoi il n'y a pas eu de vérification de tous les noeuds du camp ce matin.",
        points: { organisation: 3, logistique: 2 }
      }
    ]
  },
  {
    id: 3,
    q: "Face à un projet ambitieux, tu…",
    r: [
      {
        text: "Tu t'occupes de toute la paperasse : budget, réglementation, implantation, notes de frais, ...",
        points: { organisation: 3, methode: 2 }
      },
      {
        text: "Tu contactes tes soutiens pédagogiques et tes RG pour avoir tout le soutien nécessaire.",
        points: { pratique: 3, logistique: 2 }
      },
      {
        text: "Tu t'assures que chacun s'épanouisse et grandisse dans le projet.",
        points: { reveur: 3, espritDeCorps: 1 }
      },
      {
        text: "Tu te laisses une marge pour l'impro' face à la réalité du terrain. ",
        points: { debrouille: 3, animation: 2 }
      }
    ]
  },
  {
    id: 4,
    q: "L'ambiance idéale d'une réunion d'équipe c'est…",
    r: [
      {
        text: "Un ordre du jour clair, un temps défini, et une répartition efficace des tâches.",
        points: { organisation: 3, logistique: 2 }
      },
      {
        text: "Un grand débriefing informel, des blagues, et des idées qui fusent (Le Fun).",
        points: { animation: 3, debrouille: 2 }
      },
      {
        text: "Un moment convivial où chacun peut exprimer ses réussites et ses difficultés. ",
        points: { espritDeCorps: 3, methode: 1 }
      },
      {
        text: "La rigueur dans l'exécution des décisions prises.",
        points: { methode: 3, organisation: 1 }
      }
    ]
  },
  {
    id: 5,
    q: "Ta plus grande fierté de cette année :",
    r: [
      {
        text: "Sauver le repas du week-end de groupe lorsque les jeunes ont renversé la gamelle sur le feu. ",
        points: { debrouille: 3, pratique: 2 }
      },
      {
        text: "Avoir créé une ambiance d'équipe incroyable dans ton échelon. Du jamais-vu.",
        points: { animation: 3, espritDeCorps: 2 }
      },
      {
        text: "Avoir bouclé un dossier (de camp, de subvention, ...) en un temps record.",
        points: { methode: 3, organisation: 2 }
      },
      {
        text: "La plus belle implantation de camp/organisation de local matos que le scoutisme ait connu.",
        points: { pratique: 3, logistique: 1 }
      }
    ]
  },
  {
    id: 6,
    q: "La musique indispensable à chanter lors de la vaisselle, c'est…",
    r: [
      {
        text: "Quand la musique est bonne (si possible en hurlant), pour que toute la forêt vous entende pendant qu'on frotte les gamelles. ",
        points: { animation: 3, logistique: 1 }
      },
      {
        text: "L'alphabet scout, une valeur sûre que tout le monde connait par coeur. ",
        points: { espritDeCorps: 2, debrouille: 2 }
      },
      {
        text: "Le Port de Lorient, une berceuse douce à chanter en canon.",
        points: { reveur: 3, methode: 1 }
      },
      {
        text: "La Red River Valley, pour tenir la cadence de la vaisselle.",
        points: { animation: 3, pratique: 1 }
      }
    ]
  },
  {
    id: 7,
    q: "La transmission, c'est ta priorité. Tu as passé du temps à : ",
    r: [
      {
        text: "Former quelqu'un à une tâche concrète : gestion du budget, procédure administrative, ...",
        points: { logistique: 3, methode: 2 }
      },
      {
        text: "Accompagner un jeune ou un nouveau bénévole pour qu'il/elle trouve sa place.",
        points: { espritDeCorps: 3, reveur: 2 }
      },
      {
        text: "Expliquer le cadre réglementaire et la sécurité aux nouveaux bénévoles.",
        points: { pratique: 3, organisation: 2 }
      },
      {
        text: "Préparer des fiches activités et des supports pédagogiques.",
        points: { methode: 3, animation: 2 }
      }
    ]
  },
  {
    id: 8,
    q: "Pour toi, le feu, c'est…",
    r: [
      {
        text: "Une source de chaleur, mais aussi une source de risque.",
        points: { organisation: 3, logistique: 1 }
      },
      {
        text: "Tout un art : avec une pyramide bien construite, je n'ai besoin que d'une allumette.",
        points: { pratique: 3, reveur: 1 }
      },
      {
        text: "Un support pédagogique pour apprendre l'autonomie et la débrouille aux jeunes.",
        points: { animation: 3, espritDeCorps: 2 }
      },
      {
        text: "Un symbole fort de notre lien avec la nature et la vie en plein air.",
        points: { reveur: 3, pratique: 1 }
      }
    ]
  },
  {
    id: 9,
    q: "Un parent de jeune vient te voir, furieux. Ta réaction :",
    r: [
      {
        text: "Dans ta tête, tu te refais mentalement toute la réglementation pour savoir ce qui a manqué.",
        points: { organisation: 3, methode: 2 }
      },
      {
        text: "Tu commences par l'écouter calmement et lui proposer un café.",
        points: { espritDeCorps: 3, animation: 1 }
      },
      {
        text: "Tu t'imagines déjà appeler ton responsable pour trouver des solutions.",
        points: { logistique: 3, debrouille: 2 }
      },
      {
        text: "Tu fais venir un témoin pour écouter l'échange et prendre des notes.",
        points: { methode: 3, organisation: 1 }
      }
    ]
  },
  {
    id: 10,
    q: "Ta zone de confort à toi, c'est :",
    r: [
      {
        text: "Carte et boussole en main, même sans réseau.",
        points: { pratique: 3, logistique: 2 }
      },
      {
        text: "Raconter une histoire au coin du feu, ou animer un atelier de formation.",
        points: { animation: 3, reveur: 2 }
      },
      {
        text: "Faire le bilan d'un projet et valider les objectifs qui ont été réussis. ",
        points: { methode: 3, organisation: 1 }
      },
      {
        text: "Réparer quelque chose ou faire face à un imprévu.",
        points: { debrouille: 3, pratique: 2 }
      }
    ]
  },
  {
    id: 11,
    q: "Une anecdote sur un de tes talents, c'est...",
    r: [
      {
        text: "Avoir réparé la tente intendance après l'orage (elle était encore plus solide après).",
        points: { pratique: 3, debrouille: 2 }
      },
      {
        text: "Avoir convaincu un nouveau parent de s'engager, ou une collectivité de soutenir un projet.",
        points: { espritDeCorps: 2, reveur: 3 }
      },
      {
        text: "Avoir fait le plus beau déguisement de veillée (les louveteaux-jeannettes y croyaient).",
        points: { animation: 3, methode: 1 }
      },
      {
        text: "Avoir réussi à tenir le planning vraiment serré d'un week-end.",
        points: { organisation: 3, logistique: 2 }
      }
    ]
  },
  {
    id: 12,
    q: "Ce qui te donne le plus de motivation pour te réengager, c'est…",
    r: [
      {
        text: "Le sentiment du devoir accompli : tout était carré, personne n'a manqué de rien.",
        points: { logistique: 3, organisation: 2 }
      },
      {
        text: "La qualité des relations et de l'ambiance dans ton équipe.",
        points: { espritDeCorps: 3, reveur: 1 }
      },
      {
        text: "Les idées de jeux ou de projets que tu as envie de mettre en place.",
        points: { methode: 2, animation: 3 }
      },
      {
        text: "Les défis techniques qui restent à relever sur le camp ou le local !",
        points: { pratique: 3, logistique: 1 }
      }
    ]
  },
  {
    id: 13,
    q: "Ton plus grand drame scout de l'année ?",
    r: [
      {
        text: "Avoir oublié le cinquième lors d'un week-end de groupe...",
        points: { espritDeCorps: 3, debrouille: 2 }
      },
      {
        text: "Avoir oublié les cartes pour le grand jeu que tu avais mis une semaine à organiser...",
        points: { methode: 2, reveur: 3 }
      },
      {
        text: "Avoir sous-estimé l'appétit de ton équipe au petit déj' : il a fallu retourner chercher des baguettes...",
        points: { logistique: 3, organisation: 2 }
      },
      {
        text: "Avoir oublié la batte de thèque gravée par les jeunes dans le train, au premier jour du camp...",
        points: { pratique: 2, organisation: 1 }
      }
    ]
  },
  {
    id: 14,
    q: "Ton engagement hors SGDF se traduit par…",
    r: [
      {
        text: "Jardin partagé ou bricolage avec des personnes isolées.",
        points: { pratique: 3, methode: 1 }
      },
      {
        text: "Être à fond dans ta vie de quartier : maraudes, MJC, ...",
        points: { reveur: 3, organisation: 2 }
      },
      {
        text: "Organiser des anniversaires inoubliables pour ta famille et tes amis.",
        points: { logistique: 3, animation: 2 }
      },
      {
        text: "Rendre service aux gens autour de toi : porter des sacs de course, tenir la porte, ...",
        points: { debrouille: 3, espritDeCorps: 1 }
      }
    ]
  },
  {
    id: 15,
    q: "Comment tu gères ton temps, avec le bénévolat et le reste ?",
    r: [
      {
        text: "Je planifie des créneaux : en dehors, tu me parles pas des scouts !",
        points: { organisation: 3, methode: 2 }
      },
      {
        text: "Je fais beaucoup de \"petites\" tâches au fil de la semaine.",
        points: { methode: 3, logistique: 2 }
      },
      {
        text: "Je fais tout à la dernière minute, c'est dans l'urgence que j'ai le plus d'inspi'.",
        points: { debrouille: 3, animation: 1 }
      },
      {
        text: "J'anticipe, pour expliquer aux nouveaux comment je fais pour qu'ils puissent être autonomes.",
        points: { espritDeCorps: 3, reveur: 1 }
      }
    ]
  },
  {
    id: 16,
    q: "Face à un conflit d'équipe, ton réflexe :",
    r: [
      {
        text: "Faire une médiation, pour que chacun puisse s'exprimer et trouver des solutions.",
        points: { organisation: 3, methode: 2 }
      },
      {
        text: "J'écoute les gens un à un, pour recevoir leurs émotions et entendre leurs besoins.",
        points: { espritDeCorps: 3, animation: 2 }
      },
      {
        text: "J'organise une activité de cohésion, pour relâcher la tension et avancer ensemble.",
        points: { pratique: 2, logistique: 1 }
      },
      {
        text: "J'attends, car souvent les tensions se règlent d'elles-mêmes quand les émotions retombent.",
        points: { debrouille: 3, reveur: 1 }
      }
    ]
  },
  {
    id: 17,
    q: "Mon objet fétiche, toujours dans ma poche de chemise :",
    r: [
      {
        text: "Mon opinel, pour faire face à toutes les situations.",
        points: { pratique: 3, debrouille: 2 }
      },
      {
        text: "Mon carnet de chants, pour mettre l'ambiance et faire découvrir nos classiques aux nouveaux.",
        points: { espritDeCorps: 3, animation: 2 }
      },
      {
        text: "Une batterie externe, pour rester toujours joignable au cas-où.",
        points: { methode: 3, organisation: 1 }
      },
      {
        text: "Des mouchoirs, pour les bobos ou les rhumes : j'anticipe !",
        points: { organisation: 3, logistique: 2 }
      }
    ]
  },
  {
    id: 18,
    q: "Premier jour de camp : le terrain où vous aviez prévu de camper est gorgé d'eau, un vrai champ de boue.",
    r: [
      {
        text: "Avec l'accord du proprio, tu déplaces le camp sur une zone plus petite mais moins boueuse.",
        points: { logistique: 3, debrouille: 2 }
      },
      {
        text: "Tu sors ton livre de froissartage : tentes surélevées pour tout le monde !",
        points: { pratique: 3, methode: 2 }
      },
      {
        text: "Tu réunis ta maîtrise et vous passez des coups de fil pour trouver un autre lieu à proximité.",
        points: { organisation: 3, methode: 1 }
      },
      {
        text: "Ça tombe bien, les jeunes ont des bottes : c'est parti pour un grand jeu !",
        points: { animation: 3, espritDeCorps: 1 }
      }
    ]
  },
  {
    id: 19,
    q: "La loi scoute, pour toi, c'est ...",
    r: [
      {
        text: "Ton fond d'écran de téléphone, pour t'en inspirer au quotidien.",
        points: { reveur: 3, espritDeCorps: 2 }
      },
      {
        text: "Un guide, le cadre indispensable pour organiser des camps en sécurité et mettre les jeunes en confiance.",
        points: { organisation: 3, methode: 2 }
      },
      {
        text: "Une pancarte accrochée au milieu du camp, pour animer des débats avec les jeunes.",
        points: { animation: 3, pratique: 1 }
      },
      {
        text: "Un texte que l'on doit s'approprier à notre époque, et interpréter avec créativité.",
        points: { debrouille: 2, reveur: 1 }
      }
    ]
  },
  {
    id: 20,
    q: "Un événement scout international, pour toi, c'est...",
    r: [
      {
        text: "Un projet super ambitieux : une logistique complexe et plein de défis à relever.",
        points: { logistique: 3, organisation: 2 }
      },
      {
        text: "Le sens du scoutisme et du guidisme : la rencontre et la fraternité au-delà des frontières.",
        points: { reveur: 3, espritDeCorps: 2 }
      },
      {
        text: "L'opportunité d'apprendre des nouvelles langues et de découvrir de nouvelles cultures ! ",
        points: { pratique: 3, debrouille: 2 }
      },
      {
        text: "L'occasion rêvée de faire une vidéo pour raconter ce que tu as vécu, et donner la parole aux participants.",
        points: { methode: 3, reveur: 1 }
      }
    ]
  },
  {
    id: 21,
    q: "Ton ingrédient secret pour un grand jeu inoubliable :",
    r: [
      {
        text: "Un imaginaire bien ficelé, avec des rebondissements et des déguisements incroyables. ",
        points: { methode: 3, animation: 2 }
      },
      {
        text: "Un jeu en plusieurs parties, pour que tout le monde s'amuse.",
        points: { pratique: 3, logistique: 2 }
      },
      {
        text: "Quand la solution pour gagner le jeu, c'est la coopération et l'entraide entre les équipes.",
        points: { debrouille: 3, espritDeCorps: 2 }
      },
      {
        text: "Une zone de jeu balisée, des jeunes avec des chaussures fermées et des casquettes : aucun risque !",
        points: { organisation: 3, pratique: 1 }
      }
    ]
  }
];
// Les résultats (Code MBTI SGDF à 4 lettres)
// Définissez les 16 combinaisons ici avec des profils percutants !
const resultatsMBTI = {   // Profils dominés par Logistique (L)
  'LPOM': {
    nom: "L'Ancre",
    picto: "ancre",
    descriptionShort: "Il/Elle est le garant(e) de la stabilité, assurant que l'organisation repose sur des bases solides et sécurisées.",
    description: "En tant qu'Ancre de la structure, tu es notre pilier de confiance. Tu as le calme nécessaire pour anticiper tous les risques et tu excelles à transformer le chaos en clarté. Tu mets en place l'organisation et la méthode nécessaire pour garantir la sécurité et la pérennité de notre action, permettant à tout le monde d'avancer sans risque ni hésitation."
  },
  'LPOD': {
    nom: "La Vision",
    picto: "observation",
    descriptionShort: "Il/Elle excelle dans la gestion concrète et apporte des solutions pragmatiques et ingénieuses face à l'imprévu.",
    description: "Tu es le Bâtisseur solide qui ne recule devant rien. Tu organises les aspects pratiques de nos projets avec un sens du détail exceptionnel. Mais ta vraie force, c'est ta capacité à utiliser ta débrouille pour improviser une solution fiable et efficace, transformant chaque obstacle en une opportunité pour l'équipe."
  },
  'LPEM': {
    nom: "La Transmission",
    picto: "f-tech",
    descriptionShort: "Il/Elle est le mentor qui transmet les compétences et les méthodes avec une pédagogie structurée.",
    description: "Ton rôle de Garant du savoir-faire est d'élever notre niveau collectif. Tu partages tes connaissances avec patience et une méthode rigoureuse, assurant que les compétences cruciales sont comprises et maîtrisées par tous. Tu es la mémoire vivante de nos meilleures pratiques et tu formes la prochaine génération d'experts."
  },
  'LPED': {
    nom: "Le Pilier",
    picto: "temple",
    descriptionShort: "Il/Elle est l'âme de l'intendance, gérant le quotidien et le bien-être avec une énergie positive et une grande adaptabilité.",
    description: "En tant que Soutien qui tient chaud, tu es le réconfort de l'équipe. Tu t'occupes du concret avec une générosité et une énergie débordantes. Tu es toujours là pour assurer le confort physique et moral, utilisant ton sens de la débrouille pour créer une ambiance chaleureuse et bienveillante, même dans les conditions les plus rudes."
  },
  'LROM': {
    nom: "La Prévoyance",
    picto: "destination",
    descriptionShort: "C'est l'architecte de l'avenir, capable de transformer une grande vision en une stratégie claire et organisée.",
    description: "Ton rôle est celui du Stratège prévoyant, notre boussole à long terme. Tu es celui/celle qui regarde au-delà de l'horizon immédiat, conceptualisant l'avenir. Tu as le talent de prendre une vision ambitieuse et de la décomposer en une feuille de route claire et méthodique pour que l'équipe sache exactement comment concrétiser ce rêve."
  },
  'LROD': {
    nom: "L'Agile",
    picto: "bateau",
    descriptionShort: "Il/Elle est le guide qui sait naviguer entre la vision ambitieuse et la réalité du terrain, s'adaptant rapidement.",
    description: "En tant que Pilote agile, tu es le pont entre le rêve et la réalité. Tu cadres nos grands projets avec une organisation solide, mais tu es le premier à accepter l'imprévu comme une force. Tu sais ajuster le cap avec une grande rapidité, faisant de chaque changement de dernière minute une opportunité pour une aventure encore plus grande."
  },
  'LREM': {
    nom: "La Bienveillance",
    picto: "solidarite",
    descriptionShort: "Il/Elle est le formateur de leaders, créant un environnement structuré pour le développement personnel et collectif.",
    description: "Ton rôle de Compagnon tuteur est d'inspirer la croissance. Tu as la capacité unique d'encadrer les autres avec bienveillance tout en leur donnant les outils méthodologiques pour se dépasser. Tu crées un espace sécurisant et structuré où chacun est encouragé à prendre des responsabilités et à réaliser son potentiel maximal."
  },
  'LRED': {
    nom: "La Cohérence",
    picto: "localisation",
    descriptionShort: "Il/Elle est l'huile dans les rouages, utilisant son intuition pour souder l'équipe et résoudre les tensions humaines.",
    description: "Tu es le Moteur de cohésion, le gardien de l'harmonie. Tu utilises ton sens aigu de l'écoute et ta débrouille relationnelle pour détecter les tensions et les résoudre avant qu'elles ne s'enveniment. Ton énergie positive et ton intuition sont la clé qui maintient l'équipe unie, motivée et alignée sur un objectif commun."
  },

  // Profils dominés par Animation (A)
  'APOM': {
    nom: "La Structure",
    picto: "engrenage2",
    descriptionShort: "C'est le professionnel de la qualité, concevant des activités sécurisées, structurées et hautement pédagogiques.",
    description: "En tant qu'Artisan du programme, tu es le garant de l'excellence éducative. Tu conçois des programmes d'activités précis et engageants avec une rigueur méthodologique impressionnante. Tu es celui/celle qui s'assure que chaque moment vécu est sécurisé, structuré et qu'il permet aux jeunes de vivre des apprentissages concrets et durables."
  },
  'APOD': {
    nom: "L'Exploration",
    picto: "trek",
    descriptionShort: "Il/Elle est le cœur de l'action, capable de préparer l'aventure et de la mener à bien sur le terrain avec un grand sens pratique.",
    description: "Tu es l'Explorateur structuré, l'énergie qui met le plan en mouvement. Ton moteur, c'est l'action et le grand air ! Tu prépares les aventures avec une organisation efficace, puis tu les vis avec une passion communicative. Tu utilises ton sens pratique pour relancer le jeu, surmonter tous les défis et faire de chaque jour sur le terrain un succès."
  },
  'APEM': {
    nom: "Le Pédagogue",
    picto: "etoile",
    descriptionShort: "Il/Elle est le référent technique et humain, animant des moments qui sont des sources de croissance pour les jeunes.",
    description: "Ton rôle de Guide pédagogique est de donner du sens à l'action. Tu es le référent qui maîtrise la méthode scoute et les outils d'animation. Tu t'assures que chaque jeu, chaque discussion et chaque défi est une opportunité d'apprentissage significative, faisant de toi le catalyseur de la progression individuelle et collective."
  },
  'APED': {
    nom: "L'Énergie",
    picto: "soleil2",
    descriptionShort: "C'est la force vive, une source inépuisable d'énergie qui maintient le moral et assure le déroulement fluide des activités.",
    description: "Tu es le Moteur de l'équipe, la force vive qui ne s'arrête jamais. Ton enthousiasme est contagieux. Tu es capable de prendre les rênes, de résoudre instantanément les petits problèmes logistiques et d'animation, et d'utiliser ta débrouille naturelle pour maintenir le moral et l'engagement de tous, quoi qu'il arrive."
  },
  'AROM': {
    nom: "L'Architecte",
    picto: "compa",
    descriptionShort: "C'est le visionnaire organisé, capable de concrétiser une idée créative en un projet structuré.",
    description: "En tant qu'Architecte de l'idée, tu es celui/celle qui bâtit l'innovation. Tu captes les inspirations les plus audacieuses et tu les transformes immédiatement en un plan structuré et méthodique. Ta capacité à conjuguer rêve et organisation nous permet de concrétiser des projets visionnaires et d'explorer de nouvelles avenues pour notre mouvement."
  },
  'AROD': {
    nom: "L'Imprévu",
    picto: "difficulte",
    descriptionShort: "Il/Elle est l'organisateur créatif, capable d'improviser des activités captivantes à partir d'une simple intuition.",
    description: "Tu es l'Artisan de l'imprévu, le magicien du moment. Tu cadres les grandes lignes pour donner une direction, mais tu excelles à laisser la liberté nécessaire à l'expérimentation. Tu es capable d'improviser des moments incroyables en cours de route, utilisant ton intuition et ta débrouille pour créer des activités captivantes et inoubliables."
  },
  'AREM': {
    nom: "L'Inspiration",
    picto: "horizon",
    descriptionShort: "Il/Elle est le leader du sens, inspirant l'équipe et connectant la vision à la méthode pour un impact durable.",
    description: "Ton rôle d'Éveilleur de la vision est d'insuffler la passion et le sens. Tu inspires les autres avec ta vision, créant des liens forts basés sur des valeurs communes. Tu nous montres comment nos rêves peuvent être atteints, en guidant l'équipe à travers une méthode appliquée qui rend l'engagement significatif et durable."
  },
  'ARED': {
    nom: "L'Aventure",
    picto: "boussole",
    descriptionShort: "C'est le pur animateur, vivant pour la flamme du moment présent, l'énergie et la fraternité partagée.",
    description: "Tu es l'Âme de l'aventure, le cœur vibrant de l'équipe. Tu vis intensément le moment présent, et ta priorité est de créer une ambiance électrique, joyeuse et fraternelle. Ton enthousiasme pour le jeu, l'énergie et le partage fait de toi le moteur émotionnel qui rend chaque expérience unique et mémorable pour tous."
  }
};

// --- LOGIQUE DU QUIZ ---

/**
 * Met à jour les scores avec les points de la réponse choisie.
 * @param {object} pointsGagnes - Objet des points à ajouter aux axes.
 */
function ajouterPoints(pointsGagnes) {
    for (const axe in pointsGagnes) {
        if (scoresAxes.hasOwnProperty(axe)) {
            scoresAxes[axe] += pointsGagnes[axe];
        }
    }
}

/**
 * Affiche la question actuelle et ses propositions de réponse.
 */
function displayQuestion() {
    const quizContainer = document.getElementById('quiz-container');
    const introContainer = document.getElementById('intro-container');
    const resultContainer = document.getElementById('resultat-container');
    
    // Cache l'intro et le résultat, montre le quiz
    if (introContainer) introContainer.style.display = 'none';
    if (resultContainer) resultContainer.style.display = 'none';
    if (quizContainer) quizContainer.style.display = 'flex';

    if (currentQuestionIndex >= questionsData.length) {
        showResult();
        return;
    }

    const qData = questionsData[currentQuestionIndex];
    const questionTextElement = document.getElementById('question-text');
    const reponsesContainer = document.getElementById('reponses-container');
    const progressTextElement = document.getElementById('progress-text');

    if (!questionTextElement || !reponsesContainer || !progressTextElement) return;

    // Affichage de la question et de la progression
    questionTextElement.textContent = qData.q;
    progressTextElement.textContent = `${currentQuestionIndex + 1} / ${questionsData.length}`;

    // Affichage des réponses
    reponsesContainer.innerHTML = '';
    
    couleurCSS = ['bg-aa-light', 'bg-ff-light', 'bg-sg-light', 'bg-pc-light'];
    qData.r.forEach((reponse, index) => {
        const button = document.createElement('button');
        button.textContent = reponse.text;
        button.classList.add('rounded-xl', 'w-full', 'shadow-md', 'py-3', couleurCSS[index%4], 'text-left', 'px-4', 'transition', 'hover:bg-gray-100', 'active:bg-primary-light');
        
        // Attribution de la fonction de gestion de réponse
        button.onclick = () => handleAnswer(reponse.points);
        
        reponsesContainer.appendChild(button);
    });

    // Optionnel: Mettre à jour la barre de progression visuelle si elle existe dans le HTML
}

/**
 * Gère la sélection d'une réponse, met à jour les scores et passe à la question suivante.
 * @param {object} points - Les points à ajouter.
 */
function handleAnswer(points) {
    ajouterPoints(points);
    currentQuestionIndex++;
    displayQuestion();
}

/**
 * Détermine le code MBTI SGDF à 4 lettres.
 * @returns {string} Le code de 4 lettres (ex: LPOD).
 */
function determinerCodeFinal() {
    // Si l'un des axes est à égalité, nous donnons la priorité à la lettre du Pôle 1 (L, P, O, M)
    const L_A = scoresAxes.logistique >= scoresAxes.animation ? 'L' : 'A';
    const P_R = scoresAxes.pratique >= scoresAxes.reveur ? 'P' : 'R';
    const O_E = scoresAxes.organisation >= scoresAxes.espritDeCorps ? 'O' : 'E';
    const M_D = scoresAxes.methode >= scoresAxes.debrouille ? 'M' : 'D';

    return L_A + P_R + O_E + M_D;
}

function encoderParConcat(codeLettres) {
    const map = {
        'L': '1', 'A': '2',
        'P': '3', 'R': '4',
        'O': '5', 'E': '6',
        'M': '7', 'D': '8'
    };
    
    // Concaténation des chiffres
    return parseInt(codeLettres.split('').map(lettre => map[lettre]).join(''));
}


/**
 * Affiche le résultat final et le profil MBTI SGDF.
 */
async function showResult() {
    const finalCode = determinerCodeFinal();
    // Pour L R O D => 1458
    const nombreFinal = encoderParConcat(finalCode); 
    console.log(`Code Numérique par Concaténation: ${nombreFinal}`);


    const profil = resultatsMBTI[finalCode] || resultatsMBTI['ARED'];
if (typeof _paq !== 'undefined') {
     // 1. Définir la Dimension Personnalisée de portée Action (ID 1)
     _paq.push(['setCustomDimension', 1, finalCode]); 

     // 2. Envoyer l'événement
     // trackEvent: Catégorie, Action, Nom, Valeur
     // La 'Valeur' (le 5ème paramètre) est ici inutile si finalCode est dans la dimension personnalisée. 
     // Vous pouvez mettre une valeur numérique si pertinent (ex: 1 pour un complétion).
     _paq.push(['trackEvent', 'Quiz', 'Attribution Profil', 'Fin Quiz', nombreFinal]); 
     
     // Note: Si vous aviez un nombre à suivre (ex: score), vous pourriez faire :
     // _paq.push(['trackEvent', 'Quiz', 'Attribution Profil', 'Fin Quiz', scoreNumerique]); 
     
     console.log(`Événement Matomo tracé : Quiz - ${finalCode}`);
 }

    const quizContainer = document.getElementById('quiz-container');
    const resultContainer = document.getElementById('resultat-container');
    const loadingContainer = document.getElementById('resultat-loading');
    
    if (quizContainer) quizContainer.style.display = 'none';
    if (loadingContainer) loadingContainer.style.display = 'flex'; // Afficher le résultat

    // on bloque l'execution de la fonction de ce script en attendant que le boutton#showResult2 soit cliqué
    const showResult2Button = document.getElementById('showResult2');
    const showResult2Text = document.getElementById('showResultText');
    const picto = document.getElementById('picto');

            if (showResult2Button) showResult2Button.style.display = 'none';
    
    // attendre 3 secondes avant d'afficher le bouton
    await new Promise(resolve => {
        setTimeout(() => {
            if (showResult2Button) showResult2Button.style.display = 'block';
            if (picto) picto.classList.remove('picto-engrenage');
            if (picto) picto.parentNode.classList.remove('animate-spin');

            if (picto) picto.classList.add('picto-coche');
            if (showResult2Text) showResult2Text.textContent = "C'est prêt ! Découvre qui tu es !";
            resolve(); // Résout la première promesse après 3 sec
        }, 3000);
    });

    // 3. Attendre le clic sur le bouton
    // L'exécution du script s'arrête ici jusqu'au clic
    await new Promise((resolve) => {
        if (showResult2Button) {
            showResult2Button.addEventListener('click', () => {
                resolve(); // Résout la deuxième promesse au clic
            }, { once: true });
        } else {
            // Si le bouton n'existe pas, on résout immédiatement (ou on gère l'erreur)
            resolve(); 
        }
    });
    
    if (loadingContainer) loadingContainer.style.display = 'none';
    if (resultContainer) resultContainer.style.display = 'flex'; // Afficher le résultat

    document.getElementById('resultat-code').textContent = finalCode;
    document.getElementById('resultat-nom').textContent = profil.nom;
    document.getElementById('resultat-description').textContent = profil.description;
    

    document.getElementById('resultat-code').textContent = finalCode;
    document.getElementById('field-profil').textContent = profil.nom;
    document.getElementById('field-picto').classList.add(`picto-${profil.picto ?? 'promesse'}`);
    document.getElementById('field-picto2').classList.add(`picto-${profil.picto ?? 'promesse'}`);

    document.getElementById('field-profilDesc').textContent = profil.descriptionShort ?? profil.description;
    const fieldNom = document.getElementById('input-nom');
    if(fieldNom){
      fieldNom.addEventListener('input', (e) => {
        document.getElementById('field-nom').textContent = e.target.value || "Ton Prénom";
      });
    }
    const fieldRole = document.getElementById('input-role');
    
    if(fieldRole){
      fieldRole.addEventListener('input', (e) => {
        document.getElementById('field-role').textContent = e.target.value || "Ton Rôle";
      });
    }
    // const couleur = document.querySelector('input[type="radio"]:checked').id;

      for (const selecteur of document.querySelectorAll('input[type="radio"]')) {
        selecteur.addEventListener('change', (e) => {
          console.log(e.target.id);
          document.getElementById('img').style.backgroundColor = e.target.id;
        });
      }
    // document.getElementById('img').style.backgroundColor = couleur;


    // const imageElement = document.getElementById('resultat-image');
    // imageElement.src = `https://placehold.co/400x400/96c568/ffffff?text=${encodeURIComponent(finalCode)}`; // Placeholder SGDF
    // imageElement.alt = `Image de profil ${profil.nom}`;
    
    // Le bouton de partage pointe vers l'image placeholder
    // const shareButton = document.getElementById('bouton-partage');
    // shareButton.href = imageElement.src;
}


    // Fonction pour calculer et appliquer le scale
    function updateScale() {
      const DESIGN_WIDTH = 1080;
      const DESIGN_HEIGHT = 1920;
      const storyContainer = document.getElementById('carte-container');
      const story = document.getElementById('carte-preview');
      
      if(storyContainer && story){
        const containerWidth = storyContainer.clientWidth;
        const containerHeight = storyContainer.clientHeight;
        
        const scaleX = containerWidth / DESIGN_WIDTH;
        const scaleY = containerHeight / DESIGN_HEIGHT;
        const scale = Math.min(scaleX, scaleY) * 0.95; // 0.95 pour laisser un peu de marge
        
        story.style.transform = `scale(${scale})`;
      }
    }
    
    // Appliquer le scale immédiatement
    updateScale();
    
    // Réappliquer le scale si la fenêtre est redimensionnée
    window.addEventListener('resize', updateScale);
// Bouton de téléchargement
    const downloadButton = document.getElementById('downloadCard');
    if(downloadButton) {
      downloadButton.addEventListener('click', async () => {
        const imgElement = document.getElementById('img');
        if(!imgElement) return;
        
        // Désactiver le bouton pendant le traitement
        downloadButton.disabled = true;
        downloadButton.textContent = 'Génération en cours...';
        
        try {
          // Cloner l'élément pour la capture (sans affecter l'affichage)
          const clone = imgElement.cloneNode(true);
          
          // Positionner le clone hors écran
          clone.style.position = 'fixed';
          clone.style.left = '-9999px';
          clone.style.top = '0';
          clone.style.width = '1080px';
          clone.style.height = '1920px';
          
          // Ajouter le clone au DOM temporairement
          document.body.appendChild(clone);
          
          // Petit délai pour que le navigateur rende le clone
          await new Promise(resolve => setTimeout(resolve, 100));
          
          // Capturer le clone avec html2canvas à taille réelle
          const canvas = await html2canvas(clone, {
            width: 1080,
            height: 1920,
            scale: 1,
            backgroundColor: null,
            logging: false,
            useCORS: true,
            allowTaint: true
          });
          
          // Retirer le clone du DOM
          document.body.removeChild(clone);
          
          // Vérifier que le canvas a les bonnes dimensions
          console.log('Canvas dimensions:', canvas.width, 'x', canvas.height);
          
          // Convertir le canvas en blob
          canvas.toBlob((blob) => {
            // Créer un lien de téléchargement
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            const fileName = `mon-profil-sgdf-${document.getElementById('resultat-code').textContent}.png`;
            link.download = fileName;
            link.href = url;
            link.click();
            
            // Nettoyer
            URL.revokeObjectURL(url);
            
            // Réactiver le bouton
            downloadButton.disabled = false;
            downloadButton.innerHTML = '<i class="picto-coche"></i> Télécharger';
          }, 'image/png', 1.0); // Qualité maximale
          
        } catch (error) {
          console.error('Erreur lors de la génération de l\'image:', error);
          alert('Une erreur est survenue lors de la génération de l\'image.');
          
          downloadButton.disabled = false;
          downloadButton.innerHTML = '<i class="picto-coche"></i> Télécharger';
        }
      });
    }


function getQuizStats() {
  // Appel de votre propre endpoint sécurisé
  fetch('/dist/get_quiz_stats.php') 
    .then(response => response.json())
    .then(data => {
        // 'data' contient le JSON agrégé de Matomo
        console.log('Données des stats du quiz:', data);
        data.forEach(profil => {
            const nomProfil = profil.label;
            const nbPersonnes = profil.nb_events;
            
            // Mettre à jour l'élément HTML correspondant sur votre page
            const element = document.getElementById(`count-for-${nomProfil}`);
            if (element) {
                element.textContent = nbPersonnes;
            }
        });
    })
    .catch(error => console.error('Erreur lors du chargement des stats:', error));
}

function showProfils() {
  getQuizStats();
  console.log("Affichage des profils...");
  const profilsContainer = document.getElementById('profils-container');
  if (profilsContainer) {
      profilsContainer.style.display = 'flex';
  
    // Lister les éléments de resultatsMBTI sous liste picto + nom + descriptionShort + nombre de personnes
    const profilsListContainer = document.getElementById('profils-list-container');
    if (profilsListContainer) {
        profilsListContainer.innerHTML = ''; // Clear existing content
        for (const code in resultatsMBTI) {
            const profil = resultatsMBTI[code];
            const profilElement = document.createElement('div');
            profilElement.classList.add('profil-summary', 'p-4', 'border-b', 'border-gray-300', 'flex', 'items-center', 'space-x-4');
            profilElement.innerHTML = `
                <div><i class="text-3xl picto-${profil.picto}"></i></div>
                <div>
                    <h3 class="text-left text-lg font-bold">${profil.nom} (${code})</h3>
                    <p class="text-left text-gray-600">${profil.descriptionShort || profil.description}</p>
                </div>
            `;
            profilsListContainer.appendChild(profilElement);
                                // <p class="text-left text-gray-500" id="count-for-${profil.nom}">Chargement du nombre de personnes...</p>

        }
  
    }

  }
}

/**
 * Initialise les listeners et l'affichage initial.
 */
function initQuiz() {
    const startButton = document.getElementById('startTest');
    const showProfile = document.getElementsByClassName('showProfils');
    const closeProfileContainer = document.getElementById('closeProfilsContainer');
    
    if(closeProfileContainer){
        closeProfileContainer.addEventListener('click', () => {
          const profilsContainer = document.getElementById('profils-container');
          if (profilsContainer) profilsContainer.style.display = 'none';
        });
    }    

    if(showProfile){
      for (const btn of showProfile) {
        btn.addEventListener('click', showProfils);
      }
    }
    console.log("Initialisation du quiz...");
    if (startButton) {
        startButton.addEventListener('click', () => {
            // Réinitialiser les scores pour un nouveau test
            scoresAxes = {
                logistique: 0, animation: 0, pratique: 0, reveur: 0,
                organisation: 0, espritDeCorps: 0, methode: 0, debrouille: 0
            };
            currentQuestionIndex = 0;
            displayQuestion();
        });
    }

    // Afficher la page d'introduction au chargement
    const introContainer = document.getElementById('intro-container');
    if (introContainer) introContainer.style.display = 'flex';
    
    // Cacher le quiz et le résultat au départ
    const quizContainer = document.getElementById('quiz-container');
    const resultContainer = document.getElementById('resultat-container');
    const loadingContainer = document.getElementById('resultat-loading');
  const profilsContainer = document.getElementById('profils-container');

      if (profilsContainer) profilsContainer.style.display = 'none';

    if (quizContainer) quizContainer.style.display = 'none';
    if (resultContainer) resultContainer.style.display = 'none';
    if (loadingContainer) loadingContainer.style.display = 'none';
}

// Lancement de l'initialisation au chargement de la page
// Vous pouvez exposer les fonctions de débogage si besoin:
// window.scoresAxes = scoresAxes; 
// window.determinerCodeFinal = determinerCodeFinal;

const init = () => {
  initQuiz();
};

document.addEventListener('DOMContentLoaded', init);